<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">
        <span cvLocalizedText langSection="Common" langKey="Date">Date</span>
    </div>
    <div class="custom-setting-section-context">
        <ng-container *ngIf="settings.startDate; else noDate">
            {{ settings.startDate | date: 'shortDate' }}
        </ng-container>
        <ng-template #noDate>
            <span cvLocalizedText langSection="Controls" langKey="Today">Today</span>
        </ng-template>
    </div>
    <div class="custom-setting-section-body">
        <div class="custom-setting-section-body-row">
            <div class="custom-setting-section-body-row-label font-size-12">
                <label cvLocalizedText langSection="Common" langKey="Date">Date</label>
            </div>
            <div class="custom-setting-section-body-row-input">
                <cv-baremetrics-calendar
                    class="d-block daterange daterange--single mb-3"
                    [placeholder]="'M/D/YYYY'"
                    [(currentDate)]="settings.startDate">
                </cv-baremetrics-calendar>
            </div>
        </div>
    </div>
</cv-module-custom-setting-section>
